module.exports = __webpack_public_path__ + "static/img/72.baf0a6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/72.png
// module id = +9+H
// module chunks = 0